import "./App.css";
import { ConsentProvider } from "./context/ConsentContext";
import CookieConsent from "./components/CookieConsent";
import CookiePolicy from "./components/CookiePolicy";
import Hero from "./components/Hero";
import About from "./components/About";
import BookFeature from "./components/BookFeature";
import Videos from "./components/Videos";
import Testimonials from "./components/Testimonials";
import OtherBooks from "./components/OtherBooks";
import Donation from "./components/Donation";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";
import { Toaster } from "./components/ui/toaster";

function Landing() {
  return (
    <div className="App bg-white">
      <main>
        <Hero />
        <About />
        <BookFeature />
        <Videos />
        <Testimonials />
        <OtherBooks />
        <Donation />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
}

function App() {
  const isCookiePolicy =
    typeof window !== "undefined" &&
    window.location.pathname.replace(/\/+$/, "") === "/politique-cookies";

  return (
    <ConsentProvider>
      {isCookiePolicy ? <CookiePolicy /> : <Landing />}
      <CookieConsent />
      <ScrollToTop />
    </ConsentProvider>
  );
}

export default App;
